const CONFIG_VALUES = {
  PORT: import.meta.env.EDS_PORT || 3000,
  APP_ENV: import.meta.env.EDS_APP_ENV || "development",
  SITE_URL: import.meta.env.EDS_SITE_URL || "http://localhost:3000",
  HOST_API: import.meta.env.EDS_HOST_API || "http://localhost:3000/api",
  AUTH_TOKEN_KEY: "EDUSOGNO_21ca37f1",
  IELTS_CHECK_INFO:
    "https://www.britishcouncil.it/en/exam/ielts/dates-fees-locations",
};

export default CONFIG_VALUES;
